module.exports = __webpack_public_path__ + "img/reid-state-logo.16c8238e.jpg";